import React from 'react';
import { Target, Users, Award, Lightbulb } from 'lucide-react';

const AboutSection = () => {
  const values = [
    {
      icon: Target,
      title: 'Mission-Driven',
      description: 'We focus on delivering solutions that create real business impact.'
    },
    {
      icon: Users,
      title: 'Client-Centric',
      description: 'Your success is our success. We partner with you every step of the way.'
    },
    {
      icon: Award,
      title: 'Excellence',
      description: 'We maintain the highest standards in code quality and delivery.'
    },
    {
      icon: Lightbulb,
      title: 'Innovation',
      description: 'We stay ahead of technology trends to give you competitive advantage.'
    }
  ];

  return (
    <section id="about" className="py-32 bg-[#121212] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 grid-pattern opacity-50"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="text-[#06B6D4] text-sm font-medium tracking-wider uppercase mb-4 block">
              About Us
            </span>
            <h2 className="text-4xl lg:text-5xl font-semibold text-white mb-6 leading-tight">
              Your Partner in
              <br />
              <span className="text-[#06B6D4]">Digital Transformation</span>
            </h2>
            <div className="space-y-6 text-white/70 text-lg leading-relaxed">
              <p>
                AskTech Solutions is a technology consultancy founded by industry veterans with decades of combined experience in software development, AI, and digital transformation.
              </p>
              <p>
                We believe in building long-term partnerships with our clients, understanding their unique challenges, and delivering tailored solutions that drive measurable results.
              </p>
              <p>
                Our team combines deep technical expertise with strategic business acumen to help organizations navigate the complexities of modern technology landscape.
              </p>
            </div>
          </div>

          {/* Right - Values Grid */}
          <div className="grid grid-cols-2 gap-6">
            {values.map((value, index) => {
              const IconComponent = value.icon;
              return (
                <div
                  key={index}
                  className="bg-black/50 border border-white/10 p-6 hover:border-[#06B6D4]/30 transition-all duration-300 group"
                >
                  <div className="w-12 h-12 bg-[#06B6D4]/10 flex items-center justify-center mb-4 group-hover:bg-[#06B6D4]/20 transition-colors">
                    <IconComponent className="w-6 h-6 text-[#06B6D4]" />
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-2">{value.title}</h3>
                  <p className="text-white/60 text-sm leading-relaxed">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
